import React from 'react'

const Location2 = ({className="w-5 h-5"}) => {
  return (
    <div>
      <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
        <g clipPath="url(#clip0_1559_8887)">
          <path d="M39.9999 79.9998C62.0913 79.9998 79.9998 62.0913 79.9998 39.9999C79.9998 17.9086 62.0913 0 39.9999 0C17.9086 0 0 17.9086 0 39.9999C0 62.0913 17.9086 79.9998 39.9999 79.9998Z" fill="url(#paint0_linear_1559_8887)" />
          <path d="M40.0009 75.2114L28.2363 54.8352H40.0009H51.7651L40.0009 75.2114Z" fill="url(#paint1_linear_1559_8887)" />
          <path d="M40.0004 60.6643C55.43 60.6643 67.9383 48.1561 67.9383 32.7265C67.9383 17.2968 55.43 4.78857 40.0004 4.78857C24.5707 4.78857 12.0625 17.2968 12.0625 32.7265C12.0625 48.1561 24.5707 60.6643 40.0004 60.6643Z" fill="url(#paint2_linear_1559_8887)" />
          <path d="M40.0005 50.4751C49.8027 50.4751 57.749 42.5288 57.749 32.7266C57.749 22.9243 49.8027 14.978 40.0005 14.978C30.1982 14.978 22.252 22.9243 22.252 32.7266C22.252 42.5288 30.1982 50.4751 40.0005 50.4751Z" fill="url(#paint3_linear_1559_8887)" />
        </g>
        <defs>
          <linearGradient id="paint0_linear_1559_8887" x1="11.7159" y1="11.7145" x2="68.2853" y2="68.284" gradientUnits="userSpaceOnUse">
            <stop stopColor="#7693FF" />
          </linearGradient>
          <linearGradient id="paint1_linear_1559_8887" x1="14.6943" y1="65.023" x2="63.3481" y2="65.023" gradientUnits="userSpaceOnUse">
            <stop stopColor="#5262E6" />
            <stop offset="1" stopColor="#0021B5" />
          </linearGradient>
          <linearGradient id="paint2_linear_1559_8887" x1="14.6946" y1="32.7256" x2="63.3484" y2="32.7256" gradientUnits="userSpaceOnUse">
            <stop stopColor="#2499FF" />
            <stop offset="1" stopColor="#004DB1" />
          </linearGradient>
          <linearGradient id="paint3_linear_1559_8887" x1="14.6947" y1="32.7257" x2="63.3485" y2="32.7257" gradientUnits="userSpaceOnUse">
            <stop stopColor="white" />
            <stop offset="1" stopColor="#C8C6CC" />
          </linearGradient>
          <clipPath id="clip0_1559_8887">
            <rect width="80" height="80" fill="white" />
          </clipPath>
        </defs>
      </svg>

    </div>
  )
}

export default Location2